"use client";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  SET_DATE_SELECTED,
  SET_AMOUNT_MATCHES_CURRENT_ALL,
  SET_TOTAL_MATCHES_ALL,
  SET_AMOUNT_MATCHES_CURRENT_LIVE,
  SET_TOTAL_MATCHES_LIVE,
  SET_AMOUNT_MATCHES_CURRENT_RESULT,
  SET_TOTAL_MATCHES_RESULT,
  SET_SEARCH_TEXT_VALUE,
  SET_SEARCH_TYPE
} from "@/lib/redux/reducers/actionTypes";
// import moment from "moment-timezone";
import DateRange from "@/public/Date_range_duotone.svg";
import DateRange_Dark from "@/public/Date_range_duotone_dark.svg";
import DateRange_Light from "@/public/Date_range_duotone_light.svg"
import ICON_ARROW_DOWN from "@/public/arrow_down.svg";
import ICON_ARROW_DOWN_DARK from "@/public/arrow_down_dark.svg";
import "../PopupButton/popupButton.scss";
import { Image } from '@/lib/target';
import { useIsMobile } from "@/lib/isMobile";
import { FILTER_TYPE } from '@/contants'
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const getDates = (pastDateDisabled, futureDateDisabled) => {
  if (pastDateDisabled) {
    return Array.from({ length: 15 }, (_, i) =>
      dayjs()
        .add(i, "days")
        .format("DD-MM-YYYY")
    );

  }

  if (futureDateDisabled) {
    return Array.from({ length: 15 }, (_, i) =>
      dayjs()
        .add(i - 14, "days")
        .format("DD-MM-YYYY")
    );
  }

  return Array.from({ length: 15 }, (_, i) =>
    dayjs()
      .add(i - 7, "days")
      .format("DD-MM-YYYY")
  );
};

const SelectButtonDate = ({
  pastDateDisabled = false,
  futureDateDisabled = false,
}) => {
  const popoverRefs = useRef([]);
  const dates = getDates(pastDateDisabled, futureDateDisabled);
  const isMobile = useIsMobile();

  const [isVisible, setIsVisible] = useState(false);
  let dateState = useSelector((state) => state.searchReducer.dateSelected);
  const [selectedOption, setSelectedOption] = useState(
    dateState || dayjs().format("DD-MM-YYYY")
  );
  const [isClient, setIsClient] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsClient(true); // Đánh dấu là client-side đã được render
  }, []);
  
  useEffect(() => {
    if (dateState) {
      setSelectedOption(dateState);
    }
  }, [dateState]);
  
  const todayFormatted = isClient ? dayjs().format("DD-MM-YYYY") : "Hôm nay";

  const handleVisible = (visible) => {
    if (isMobile) {
      if (visible) {
        document.body.classList.remove('keobongvip-root');
      } else {
        document.body.classList.add('keobongvip-root');
      }
    }
    
    setIsVisible(visible);
  };

  const togglePopover = () => {
    handleVisible(!isVisible);
  };

  const handleOptionClick = (option) => {
    dispatch({ type: SET_DATE_SELECTED, payload: option });
    dispatch({ type: SET_AMOUNT_MATCHES_CURRENT_ALL, payload: 0 });
    dispatch({ type: SET_TOTAL_MATCHES_ALL, payload: 0 });
    dispatch({ type: SET_AMOUNT_MATCHES_CURRENT_LIVE, payload: 0 });
    dispatch({ type: SET_TOTAL_MATCHES_LIVE, payload: 0 });
    dispatch({ type: SET_AMOUNT_MATCHES_CURRENT_RESULT, payload: 0 });
    dispatch({ type: SET_TOTAL_MATCHES_RESULT, payload: 0 });
    dispatch({ type: SET_SEARCH_TEXT_VALUE, payload: "", });
    dispatch({ type: SET_SEARCH_TYPE, payload: FILTER_TYPE[0].value, });
    setSelectedOption(option);
    handleVisible(false);
  };

  const handleClickOutside = (event) => {
    const isOutsideAll = popoverRefs.current.every(
      (ref) => ref && !ref.contains(event.target)
    );

    if (isOutsideAll) {
      handleVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedOption]);

  const today = dayjs().format("DD/MM/YYYY")
  
  return (
    <div className="select-button-date">
      <div className="inline-block @md:hidden relative bg-white">
        <button
          onClick={togglePopover}
          className="flex items-center justify-center gap-2 px-2 py-[5px] @md:py-[5px] @lg:py-[5px] @xl:py-[0px] bg-header-blue dark:bg-league-white dark:text-league-dark-detail focus:outline-none"
        >
          <Image src={DateRange} className="block dark:hidden w-5.5 h-5.5" />
          <Image
            src={DateRange_Dark}
            className="hidden dark:block w-5.5 h-5.5"
          />
          {selectedOption === todayFormatted ? <><span className="font-montserrat font-semibold text-vibrant-red dark:text-stroke-o3 leading-4">Hôm nay</span><span className="font-montserrat font-medium text-vibrant-red dark:text-stroke-o3 text-xxs leading-3">({today})</span></> : selectedOption}
          <Image
            src={ICON_ARROW_DOWN}
            className="block dark:hidden w-2.5 h-2.5"
          />
          <Image
            src={ICON_ARROW_DOWN_DARK}
            className="hidden dark:block w-2.5 h-2.5"
          />
        </button>
        {isVisible && (
          <div className="overlay" onClick={() => handleVisible(false)}></div>
        )}
        <div
          className={`popup ${isVisible ? "visible" : ""}`}
        >
          <div className="text-gray-700 dark:text-league-dark-detail">
            <div className="bg-white-half dark:bg-league-white rounded-lg px-0 py-3">
              {dates.length > 0 &&
                dates.map((item, index) => (
                  <div
                    key={index}
                    className={`font-semibold cursor-pointer p-2.5 hover:bg-gray-200 rounded-lg ${
                      index % 2 !== 0 && "bg-vr-light-gray dark:bg-league-white"
                    } hover:bg-yellow-pastel dark:hover:bg-league-gray-dark text-xxs`}
                    onClick={() => handleOptionClick(item)}
                  >
                    {item === todayFormatted ? <><span className="font-semi-bold text-vibrant-red">{"Hôm nay"}</span><span className="text-vibrant-red">({today})</span></>: item}
                  </div>
                ))}
            </div>
            <div className="mt-[0.15rem] px-4 py-4 rounded-md bg-sm-light-gray dark:bg-league-white">
              <button
                style={{ width: "70%" }}
                className="rounded-md bg-white-half dark:bg-gray-400 dark:text-gray-900 p-3"
                onClick={togglePopover}
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden @md:inline-block relative">
        <button
          onClick={togglePopover}
          className="flex items-center justify-center h-7 gap-2 p-2 mx-3 my-[5px] bg-white-half dark:bg-league-white dark:text-stroke-o3 focus:outline-none select-button-date"
        >
          <Image src={DateRange} className="block dark:hidden w-5.5 h-5.5" />
          <Image
            src={DateRange_Light}
            className="hidden dark:block w-5.5 h-5.5"
          />
          {selectedOption === todayFormatted ? <><span className="font-montserrat font-semibold text-vibrant-red dark:text-stroke-o3 leading-4">Hôm nay</span><span className="font-montserrat font-medium text-vibrant-red dark:text-stroke-o3 text-xxs leading-3">({today})</span></> : selectedOption}
          <Image
            src={ICON_ARROW_DOWN}
            className="block dark:hidden w-2.5 h-2.5"
          />
          <Image
            src={ICON_ARROW_DOWN_DARK}
            className="hidden dark:block w-2.5 h-2.5"
          />
        </button>
        {isVisible && (
          <div
            className="absolute top-full left-0 w-[15rem] mt-1 z-40 bg-white rounded-lg shadow-lg"
          >
            <div className="text-gray-700 dark:text-league-dark-detail">
            <div className="bg-white-half dark:bg-league-white rounded-lg px-0 py-3 max-h-[300px] overflow-y-auto">
                {dates.length > 0 &&
                  dates.map((item, index) => (
                    <div
                      key={index}
                      className={`font-semibold cursor-pointer p-3 hover:bg-gray-200 rounded-lg ${
                        index % 2 !== 0 &&
                        "bg-vr-light-gray dark:bg-league-white"
                      } hover:bg-yellow-pastel dark:hover:bg-league-gray-dark`}
                      onClick={() => handleOptionClick(item)}
                    >
                      {item === todayFormatted
                        ? <span className="font-semi-bold text-vibrant-red">{"Hôm nay (" + todayFormatted + ")"}</span>
                        : item}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(SelectButtonDate);
